import { useEffect, useState } from "react";
import AdminLayout from "./components/AdminLayout";
import { supabase } from "@/lib/supabase";

type Stats = { products: number; categories: number; services: number; testimonials: number; cases: number; banners: number };

export default function DashboardPage() {
  const [stats, setStats] = useState<Stats>({ products: 0, categories: 0, services: 0, testimonials: 0, cases: 0, banners: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const [p, c, s, t, cs, b] = await Promise.all([
        supabase.from("products").select("id", { count: "exact", head: true }),
        supabase.from("categories").select("id", { count: "exact", head: true }),
        supabase.from("services").select("id", { count: "exact", head: true }),
        supabase.from("testimonials").select("id", { count: "exact", head: true }),
        supabase.from("cases").select("id", { count: "exact", head: true }),
        supabase.from("banners").select("id", { count: "exact", head: true }),
      ]);
      setStats({
        products: p.count ?? 0,
        categories: c.count ?? 0,
        services: s.count ?? 0,
        testimonials: t.count ?? 0,
        cases: cs.count ?? 0,
        banners: b.count ?? 0,
      });
      setLoading(false);
    };
    fetchStats();
  }, []);

  const cards = [
    { label: "Produtos", value: stats.products, icon: "ri-box-3-line", color: "bg-[#1B1F5E]", link: "/admin/produtos" },
    { label: "Categorias", value: stats.categories, icon: "ri-price-tag-3-line", color: "bg-[#1a1a1a]", link: "/admin/categorias" },
    { label: "Serviços", value: stats.services, icon: "ri-settings-3-line", color: "bg-[#1B1F5E]", link: "/admin/servicos" },
    { label: "Depoimentos", value: stats.testimonials, icon: "ri-chat-quote-line", color: "bg-[#1a1a1a]", link: "/admin/depoimentos" },
    { label: "Cases", value: stats.cases, icon: "ri-folder-image-line", color: "bg-[#1B1F5E]", link: "/admin/cases" },
    { label: "Banners", value: stats.banners, icon: "ri-image-line", color: "bg-[#1a1a1a]", link: "/admin/banners" },
  ];

  return (
    <AdminLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1a1a1a]">Dashboard</h1>
        <p className="text-gray-500 text-sm mt-1">Visão geral do painel administrativo</p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-40">
          <div className="w-6 h-6 flex items-center justify-center text-[#1B1F5E]">
            <i className="ri-loader-4-line animate-spin text-2xl"></i>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cards.map((card) => (
            <a key={card.label} href={card.link} className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#1B1F5E] transition-colors cursor-pointer block">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-10 h-10 ${card.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${card.icon} text-white text-lg`}></i>
                </div>
                <span className="text-3xl font-bold text-[#1a1a1a]">{card.value}</span>
              </div>
              <p className="text-gray-600 text-sm font-medium">{card.label}</p>
            </a>
          ))}
        </div>
      )}

      <div className="mt-8 bg-white rounded-xl border border-gray-200 p-6">
        <h2 className="text-base font-bold text-[#1a1a1a] mb-4">Acesso Rápido</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {cards.map((card) => (
            <a key={card.label} href={card.link} className="flex items-center gap-3 p-3 rounded-lg border border-gray-100 hover:border-[#1B1F5E] hover:bg-[#00b5a5]/5 transition-colors cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center text-[#1B1F5E]">
                <i className={`${card.icon} text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-[#333]">Gerir {card.label}</span>
            </a>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
